import { Component } from '@angular/core';

@Component({
  selector: 'Assessment',
  templateUrl: './Assessment.component.html',
})
export class AssessmentComponent {

}
